import { SvgIconProps, SvgIcon } from '@mui/material';
import {
  BTC_SVG,
  ETH_SVG,
  USDT_SVG,
  AUSD_SVG,
  MATIC_SVG,
  BNB_SVG,
  SOL_SVG,
  AVAX_SVG,
  TRX_SVG,
  ZEC_SVG,
  DEFAULT_SVG,
  PERPL_SVG,
  HYPE_SVG,
  PUMP_SVG,
  LIT_SVG,
  VVV_SVG,
  NEAR_SVG,
  UNI_SVG,
  ARB_SVG,
  AAVE_SVG,
  MORPHO_SVG,
  ENA_SVG,
} from './crypto_svgs';

const CRYPTO_SVGS: Record<string, React.ReactNode> = {
  BTC: BTC_SVG,
  ETH: ETH_SVG,
  USDT: USDT_SVG,
  AUSD: AUSD_SVG,
  MATIC: MATIC_SVG,
  BNB: BNB_SVG,
  SOL: SOL_SVG,
  AVAX: AVAX_SVG,
  TRX: TRX_SVG,
  ZEC: ZEC_SVG,
  PERPL: PERPL_SVG,
  HYPE: HYPE_SVG,
  PUMP: PUMP_SVG,
  LIT: LIT_SVG,
  VVV: VVV_SVG,
  NEAR: NEAR_SVG,
  UNI: UNI_SVG,
  ARB: ARB_SVG,
  AAVE: AAVE_SVG,
  MORPHO: MORPHO_SVG,
  ENA: ENA_SVG,
};

export function CryptoIcon({ symbol, ...props }: { readonly symbol?: string } & SvgIconProps) {
  return <SvgIcon {...props}>{symbol && CRYPTO_SVGS[symbol] ? CRYPTO_SVGS[symbol] : DEFAULT_SVG}</SvgIcon>;
}
